export default {
  // baseUrl: "http://localhost:8082/api/v1/",
  // baseUrl: "http://ps.arian.co.ir:8084/api/v1/",
  baseUrl: "http://atlas.investinwa.ir/back/api/v1/", 
  // baseUrl: "http://tahlil.arian.co.ir/back/api/v1/",
  geoApifyAccessToken: "5b58384d0f4245b4b76b40d623c74b9c",  
  panelAdmin: "http://atlas-admin.investinwa.ir/auth/login",
  isIntersectionAvailable: true,
  isPotentialAvailable: true,
};
